import {MessageBox,Notification} from "element-ui"
import router from "@/router"
import axios from "@/api/http"

export function toDataAnalysis(){
  MessageBox.confirm('数据可视化分析功能免费试用中，欢迎使用。有任何建议欢迎反馈至平台管理员', '提示', {
    confirmButtonText: '确认进入',
    cancelButtonText: '取消',
    type: 'warning',
    showClose: false
  }).then(() => {
    axios({
      url: '/api/log/dataAnalysis',
      method: 'get',
      headers: {
        'authorization': localStorage.getItem('token')
      }
    }).then(() => {
      router.replace({ path: '/DataAnalysis' })
    }).catch(() => Notification.error({title:'失败',message:'失败请重试',position: 'bottom-right'}))
  })
}
